import { ISocialPlatform } from '@/interfaces/socials'
import { ICampaing } from '../../interfaces/portfolio'
import { IMAGE_PATHS_V2 } from './imagesPaths'
import { IUser } from '@/interfaces/user'

export const USER_EXAMPLE: IUser = {
  usernameLower: 'tramanager',
  email: 'tramanager@lstagency.com',
  lastName: 'Neal',
  socials: [
    {
      platform: ISocialPlatform.TIKTOK,
      audience: 2206491,
      identifier: 'tramanager',
    },
  ],
  username: 'Tramanager',
  firstName: 'Tremane',
}

export const PORTFOLIO_EXAMPLE: ICampaing[] = [
  {
    id: '1',
    title: 'Tommy Hilfiger Campaign',
    image: IMAGE_PATHS_V2.profileDemo + 'portfolio/project_cover_1.png',
    engagementRate: 23.19,
    description:
      'Inspired by Andy Warhol’s Factory, the fall 2022 campaign from Tommy Hilfiger takes on a creative spirit. The realms of music, fashion, and art collide with a cast that includes Kate Moss, her daughter Lila Moss, Soo Joo Park, Georgia Palmer, Jon Batiste, Travis Barker, Anthony Ramos, Lady Bunny, Steve Wiebe, and others.',
    insights: {
      audience: 2206491,
      comments: 4131,
      views: 10756,
      engagement: 23,
    },
    items: [
      {
        image: IMAGE_PATHS_V2.profileDemo + 'portfolio/projects/image_1.png',
        title: 'Tommy Hilfiger Campaign',
        impressions: '234.943',
        reach: '212.232',
        linksClicks: '23.19%',
        typePost: 'Stories',
        platoform: ISocialPlatform.INSTAGRAM,
      },
      {
        image: IMAGE_PATHS_V2.profileDemo + 'portfolio/projects/image_2.png',
        title: 'Tommy Hilfiger Campaign 2',
        impressions: '234.943',
        reach: '212.232',
        linksClicks: '23.19%',
        typePost: 'Stories',
        platoform: ISocialPlatform.INSTAGRAM,
      },
      {
        image: IMAGE_PATHS_V2.profileDemo + 'portfolio/projects/image_3.png',
        title: 'Tommy Hilfiger Campaign 3',
        impressions: '234.943',
        reach: '212.232',
        linksClicks: '23.19%',
        typePost: 'Stories',
        platoform: ISocialPlatform.INSTAGRAM,
      },
      {
        image: IMAGE_PATHS_V2.profileDemo + 'portfolio/projects/image_4.png',
        title: 'Tommy Hilfiger Campaign 4',
        impressions: '234.943',
        reach: '212.232',
        linksClicks: '23.19%',
        typePost: 'Stories',
        platoform: ISocialPlatform.INSTAGRAM,
      },
    ],
  },
  {
    id: '2',
    title: 'Photoshoot for Nike',
    image: IMAGE_PATHS_V2.profileDemo + 'portfolio/project_cover_2.png',
    description:
      'Inspired by Andy Warhol’s Factory, the fall 2022 campaign from Tommy Hilfiger takes on a creative spirit. The realms of music, fashion, and art collide with a cast that includes Kate Moss, her daughter Lila Moss, Soo Joo Park, Georgia Palmer, Jon Batiste, Travis Barker, Anthony Ramos, Lady Bunny, Steve Wiebe, and others.',
    engagementRate: 19.92,
    insights: {
      audience: 2206491,
      comments: 4131,
      views: 10756,
      engagement: 23,
    },
    items: [
      {
        image: IMAGE_PATHS_V2.profileDemo + 'portfolio/projects/image_1.png',
        title: 'Tommy Hilfiger Campaign',
        impressions: '234.943',
        reach: '212.232',
        linksClicks: '23.19%',
        typePost: 'Stories',
        platoform: ISocialPlatform.INSTAGRAM,
      },
      {
        image: IMAGE_PATHS_V2.profileDemo + 'portfolio/projects/image_2.png',
        title: 'Tommy Hilfiger Campaign 2',
        impressions: '234.943',
        reach: '212.232',
        linksClicks: '23.19%',
        typePost: 'Stories',
        platoform: ISocialPlatform.INSTAGRAM,
      },
      {
        image: IMAGE_PATHS_V2.profileDemo + 'portfolio/projects/image_3.png',
        title: 'Tommy Hilfiger Campaign 3',
        impressions: '234.943',
        reach: '212.232',
        linksClicks: '23.19%',
        typePost: 'Stories',
        platoform: ISocialPlatform.INSTAGRAM,
      },
      {
        image: IMAGE_PATHS_V2.profileDemo + 'portfolio/projects/image_4.png',
        title: 'Tommy Hilfiger Campaign 4',
        impressions: '234.943',
        reach: '212.232',
        linksClicks: '23.19%',
        typePost: 'Stories',
        platoform: ISocialPlatform.INSTAGRAM,
      },
    ],
  },
  {
    id: '3',
    title: 'Nike & Jacquemus Collaboration',
    image: IMAGE_PATHS_V2.profileDemo + 'portfolio/project_cover_3.png',
    description:
      'Inspired by Andy Warhol’s Factory, the fall 2022 campaign from Tommy Hilfiger takes on a creative spirit. The realms of music, fashion, and art collide with a cast that includes Kate Moss, her daughter Lila Moss, Soo Joo Park, Georgia Palmer, Jon Batiste, Travis Barker, Anthony Ramos, Lady Bunny, Steve Wiebe, and others.',
    engagementRate: 31.63,
    insights: {
      audience: 2206491,
      comments: 4131,
      views: 10756,
      engagement: 23,
    },
    items: [
      {
        image: IMAGE_PATHS_V2.profileDemo + 'portfolio/projects/image_1.png',
        title: 'Tommy Hilfiger Campaign',
        impressions: '234.943',
        reach: '212.232',
        linksClicks: '23.19%',
        typePost: 'Stories',
        platoform: ISocialPlatform.INSTAGRAM,
      },
      {
        image: IMAGE_PATHS_V2.profileDemo + 'portfolio/projects/image_2.png',
        title: 'Tommy Hilfiger Campaign 2',
        impressions: '234.943',
        reach: '212.232',
        linksClicks: '23.19%',
        typePost: 'Stories',
        platoform: ISocialPlatform.INSTAGRAM,
      },
      {
        image: IMAGE_PATHS_V2.profileDemo + 'portfolio/projects/image_3.png',
        title: 'Tommy Hilfiger Campaign 3',
        impressions: '234.943',
        reach: '212.232',
        linksClicks: '23.19%',
        typePost: 'Stories',
        platoform: ISocialPlatform.INSTAGRAM,
      },
      {
        image: IMAGE_PATHS_V2.profileDemo + 'portfolio/projects/image_4.png',
        title: 'Tommy Hilfiger Campaign 4',
        impressions: '234.943',
        reach: '212.232',
        linksClicks: '23.19%',
        typePost: 'Stories',
        platoform: ISocialPlatform.INSTAGRAM,
      },
    ],
  },
  {
    id: '4',
    title: 'Pepsi Advertisement',
    image: IMAGE_PATHS_V2.profileDemo + 'portfolio/project_cover_4.png',
    description:
      'Inspired by Andy Warhol’s Factory, the fall 2022 campaign from Tommy Hilfiger takes on a creative spirit. The realms of music, fashion, and art collide with a cast that includes Kate Moss, her daughter Lila Moss, Soo Joo Park, Georgia Palmer, Jon Batiste, Travis Barker, Anthony Ramos, Lady Bunny, Steve Wiebe, and others.',
    engagementRate: 17.02,
    insights: {
      audience: 2206491,
      comments: 4131,
      views: 10756,
      engagement: 23,
    },
    items: [
      {
        image: IMAGE_PATHS_V2.profileDemo + 'portfolio/projects/image_1.png',
        title: 'Tommy Hilfiger Campaign',
        impressions: '234.943',
        reach: '212.232',
        linksClicks: '23.19%',
        typePost: 'Stories',
        platoform: ISocialPlatform.INSTAGRAM,
      },
      {
        image: IMAGE_PATHS_V2.profileDemo + 'portfolio/projects/image_2.png',
        title: 'Tommy Hilfiger Campaign 2',
        impressions: '234.943',
        reach: '212.232',
        linksClicks: '23.19%',
        typePost: 'Stories',
        platoform: ISocialPlatform.INSTAGRAM,
      },
      {
        image: IMAGE_PATHS_V2.profileDemo + 'portfolio/projects/image_3.png',
        title: 'Tommy Hilfiger Campaign 3',
        impressions: '234.943',
        reach: '212.232',
        linksClicks: '23.19%',
        typePost: 'Stories',
        platoform: ISocialPlatform.INSTAGRAM,
      },
      {
        image: IMAGE_PATHS_V2.profileDemo + 'portfolio/projects/image_4.png',
        title: 'Tommy Hilfiger Campaign 4',
        impressions: '234.943',
        reach: '212.232',
        linksClicks: '23.19%',
        typePost: 'Stories',
        platoform: ISocialPlatform.INSTAGRAM,
      },
    ],
  },
]

export const VIEWS_EXAMPLE = [
  {
    avatar: IMAGE_PATHS_V2.profileDemo + 'avatars/views/avatar_1.png',
    username: 'Adison Curtis',
    date: 1677102213020,
    description: 'Author, Influencer, Photographer',
  },
  {
    avatar: IMAGE_PATHS_V2.profileDemo + 'avatars/views/avatar_2.png',
    username: 'Anika Geidt',
    date: 1677102213020,
    description: 'Brand Owner',
  },
  {
    avatar: IMAGE_PATHS_V2.profileDemo + 'avatars/views/avatar_3.png',
    username: 'Paityn Franci',
    date: 1677099067427,
    description: 'Influencer',
  },
  {
    avatar: IMAGE_PATHS_V2.profileDemo + 'avatars/views/avatar_4.png',
    username: 'Cheyenne Vetrovs',
    date: 1677095467427,
    description: 'Author, Influencer, Photographer',
  },
  {
    avatar: IMAGE_PATHS_V2.profileDemo + 'avatars/views/avatar_5.png',
    username: 'Paityn Geidt',
    date: 1677091867427,
    description: 'Brand Owner',
  },
  {
    avatar: IMAGE_PATHS_V2.profileDemo + 'avatars/views/avatar_6.png',
    username: 'Alfredo Mango',
    date: 1677084667427,
    description: 'Author',
  },
  {
    avatar: IMAGE_PATHS_V2.profileDemo + 'avatars/views/avatar_7.png',
    username: 'Haylie Gouse',
    date: 1677077467427,
    description: 'Brand Owner',
  },
  {
    avatar: IMAGE_PATHS_V2.profileDemo + 'avatars/views/avatar_8.png',
    username: 'Davis Culhane',
    date: 1676929867427,
    description: 'Brand Owner',
  },
  {
    avatar: IMAGE_PATHS_V2.profileDemo + 'avatars/views/avatar_9.png',
    username: 'Jaylon Aminoff',
    date: 1676929867427,
    description: 'Influencer',
  },
  {
    avatar: IMAGE_PATHS_V2.profileDemo + 'avatars/views/avatar_10.png',
    username: 'Terry Stanton',
    date: 1676929867427,
    description: 'Brand Owner',
  },
]
